import React from 'react'
import PropTypes from 'prop-types'

class ChangeOrder extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      orderChanged: this.props.orderChanged,
      orderby: this.props.orderby,
      type: this.props.type
    }
    this.sortAlphabetical = this.sortAlphabetical.bind(this)
    this.sortRecent = this.sortRecent.bind(this)
  }

  sortAlphabetical(event) {
    if (this.state.orderby != event.target.value) {
      this.setState({ orderby: 'alpha' })
      this.props.orderChanged('alpha')
    }
  }
  sortRecent(event) {
    if (this.state.orderby != event.target.value) {
      this.setState({ orderby: 'recent' })
      this.props.orderChanged('recent')
    }
  }
  render() {
    const orderby = this.state.orderby
    const type = this.state.type
    return (
      <div className="sorting">
        {type === 'programmes' && (
          <>
            <input
              type="checkbox"
              id="sorting_programmes"
              className="disabled"
              onChange={this.sortRecent}
              value="recent"
              checked={this.state.orderby === 'recent' ? 'checked' : ''}
              hidden
            />
            <label htmlFor="sorting_programmes">
              {orderby === 'recent'
                ? 'Showing most recent first and then alphabetical order of programme name'
                : 'Change to most recent first and then alphabetical order of programme name'}
            </label>
          </>
        )}
        {type !== 'programmes' && (
          <>
            <input
              type="radio"
              id="sorting_alpha"
              onChange={this.sortAlphabetical}
              name="sorting"
              value="alpha"
              checked={this.state.orderby === 'alpha' ? 'checked' : ''}
              hidden
            />
            <label htmlFor="sorting_alpha">
              {orderby === 'alpha'
                ? 'Showing results per alphabetical order of programme name'
                : 'Change to alphabetical order of programme name'}
            </label>
            <input
              type="radio"
              id="sorting_recent"
              onChange={this.sortRecent}
              name="sorting"
              value="recent"
              checked={this.state.orderby === 'recent' ? 'checked' : ''}
              hidden
            />
            <label htmlFor="sorting_recent">
              {orderby === 'recent' ? 'Showing most recent first' : 'Change to most recent first'}
            </label>
          </>
        )}
      </div>
    )
  }
}

ChangeOrder.propTypes = {
  orderby: PropTypes.string,
  orderChanged: PropTypes.func,
  type: PropTypes.string
}

export default ChangeOrder
